module.exports = __webpack_public_path__ + "static/media/correct.7c99de9a.svg";